import { Directive, EventEmitter, Output, QueryList, ViewChildren } from '@angular/core';
import { ResourceLibraryMultipleSelectComponent } from '@klickdata/shared-components/src/resource-list/resource-library-multiple-select/resource-library-multiple-select.component';
import { Resource } from './resource.model';

@Directive()
export class CourseItemBuilderDirective {
    @Output() onMultiSelect: EventEmitter<{ res: Resource[]; isParentSubmission?: boolean }> = new EventEmitter<{
        res: Resource[];
        isParentSubmission?: boolean;
    }>();
    @ViewChildren(ResourceLibraryMultipleSelectComponent)
    resourceLibraryMultipleSelectComponents!: QueryList<ResourceLibraryMultipleSelectComponent>;
    get selectedResources(): Resource[] {
        if (!this.resourceLibraryMultipleSelectComponents) {
            return [];
        }
        // Collect all resources and remove duplicates by id
        const allResources = this.resourceLibraryMultipleSelectComponents
            .map((component) => component.selectedResources)
            .flat();

        const uniqueResourcesMap = new Map<number, Resource>();
        for (const res of allResources) {
            if (!uniqueResourcesMap.has(res.id)) {
                uniqueResourcesMap.set(res.id, res);
            }
        }
        return Array.from(uniqueResourcesMap.values());
    }
    onSubmitMultiple() {
        this.onMultiSelect.emit({ res: this.selectedResources, isParentSubmission: false });
    }
}
